import { Component, Injector, Input, OnDestroy, OnInit } from '@angular/core';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { DiscountTypeEnum } from 'src/app/enum/discount-type.enum';
import { FidelityAdvantageValidationModel } from 'src/app/models/configurators-2d/applications/kitchen/validation/base-validation-project-info';
import { StorageValidationProjectResumeTableModel } from 'src/app/models/configurators-2d/applications/storage/validation/storage-validation-models';
import { MODAL, ModalService } from 'src/app/services/modal.service';
import { TunnelService } from 'src/app/services/tunnel.service';

@Component({
  selector: 'ng-validation-project-resume-table',
  templateUrl: './validation-project-resume-table.component.html',
})
export class ValidationProjectResumeTableComponent implements OnInit, OnDestroy {
  @Input() model$: Observable<StorageValidationProjectResumeTableModel>;
  private _modelSubscription: Subscription;

  @Input() loading$: Observable<boolean>;
  private _loadingSubscription: Subscription;

  public model: StorageValidationProjectResumeTableModel;
  public loading: boolean;
  public readonly DISCOUNT_VALUE = DiscountTypeEnum;

  public readonly fidelityAdvantageValidation: BehaviorSubject<FidelityAdvantageValidationModel> =
    new BehaviorSubject<FidelityAdvantageValidationModel>(undefined);

  get discountApplied(): boolean {
    return this.tunnelService.storageTunnelData?.discountValue !== this.DISCOUNT_VALUE.Discount0;
  }

  constructor(
    public readonly tunnelService: TunnelService,
    private readonly injector: Injector
  ) {}

  ngOnInit(): void {
    this.subscribeToObservables();
  }

  ngOnDestroy(): void {
    this._modelSubscription?.unsubscribe();
    this._loadingSubscription?.unsubscribe();
  }

  private subscribeToObservables() {
    this._modelSubscription = this.model$.subscribe(model => {
      if (model) {
        this.model = model;
        this.buildFidelityAdvantageValidationModel();
      }
    });

    this._loadingSubscription = this.loading$.subscribe(loading => (this.loading = loading));
  }

  buildFidelityAdvantageValidationModel() {
    this.fidelityAdvantageValidation.next(this.model.fidelityAdvantageValidationModel);
  }

  openComparatifFinancement() {
    const modalService = this.injector.get(ModalService);
    modalService.display(MODAL.FUNDING_COMPARAISON);
  }

  openInstallationDetail() {
    const modalService = this.injector.get(ModalService);
    modalService.display(MODAL.INSTALLATION_DETAIL, {
      installationDetails: this.tunnelService.kitchenTunnelData.detailTable,
    });
  }
}
